<template>
  <div class>
    <v-toolbar dark :color="this.$gf.headerColor()">
      <v-toolbar-title>
        <v-icon class="icon">fa-plus</v-icon>Add Company
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-layout>
        <v-flex xs12>
          <v-form>
            <v-text-field
              :error-messages="messages.first_name"
              v-model="user.first_name"
              label="LEAD FIRST NAME"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.last_name"
              v-model="user.last_name"
              label="LEAD LAST NAME"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.email"
              v-model="user.email"
              label="LEAD EMAIL"
              type="text"
              filled
            ></v-text-field>
            <v-text-field
              :error-messages="messages.company_name"
              v-model="user.company_name"
              label="ORGANIZATION NAME"
              type="text"
              filled
            >
            </v-text-field>
            <v-switch
              :error-messages="messages.senso_customer"
              v-model="user.senso_customers"
              label="SENSO CLOUD CUSTOMER"
              type="checkbox"
              color="primary"
            ></v-switch>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" @click="addUser">Add Company</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import DropZone from '@/components/global/Dropzone';
export default {
  name: 'AddCompany',
  components: {
    DropZone,
  },
  props: {
    params: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      accountManagerList: [],
      user: {},
      messages: {},
      loading: false,
      successMessage: 'Company Successfully Added.',
      errorMessage:
        'Oops, something went wrong! Please check information is correct.',  
    };
  },
  computed: {
    showEmpOption2() {
      if (
        this.id == 'qnwmkv57d05blag6' ||
        this.user.partner_id == 'qnwmkv57d05blag6' ||
        this.id == 'xeml73oyko4d9qbr' ||
        this.user.partner_id == 'xeml73oyko4d9qbr'
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getAccountManagerList();
  },
  methods: {
    closePanel() {
      this.$emit('closePanel', {});
    },
    addUser() {
      this.loading = true;
      if (this.$store.getters.level == 1) {
        userAPI
          .createOwner(this.user, this.id)
          .then(() => {
            this.closePanel();
            EventBus.$emit('USERS_UPDATED', this.params);
            this.$snotify.success(this.successMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
          })
          .catch((err) => {
            this.valid = false;
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
          });
      } else {
        userAPI
          .createOwner(
            this.user,
            this.$store.getters.partnerID,
            this.$store.getters.s3Url,
            this.$store.getters.fileDetails
          )
          .then(() => {
            this.closePanel();
            EventBus.$emit('USERS_UPDATED', this.params);
            this.$snotify.success(this.successMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
          })
          .catch((err) => {
            this.valid = false;
            this.messages = this.$gf.errorResponse(err);
            this.$snotify.error(this.errorMessage);
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
            this.loading = false;
          });
      }
    },
  },
};
</script>
